export const getWorkingGroupApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
   return `settings-working-groups${queryString ? `?${queryString}` : ""}`;
};

export const addWorkingGroupApi = () => {
    return `/settings-working-groups`;
};

export const  updateWorkingGroupeApi = (params) => {
    return `/settings-working-groups/${params?.asset_slug}`;
};

export const  deleteWorkingGroupApi = (params) => {
    return `settings-working-groups`;
};